export type RunJSON = ReturnType<Run['toJSON']>

export class Run {
  readonly object = 'run'
  constructor(readonly id: string) {}

  toJSON() {
    return {
      object: this.object,
      id: this.id
    }
  }

  static fromJSON(json: RunJSON) {
    return new Run(json.id)
  }
}
